import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/vuetify.js
// module id = ./src/plugins/vuetify.js
// module chunks = 34